import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const BreachConsolePage = lazy(() => import('../components/BreachConsolePage'))

export const BreachConsoleRoute: RouteObject = {
    path: 'breach-reporting',
    element: <BreachConsolePage />,
}

export default BreachConsoleRoute
